import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {AdminRefineProvider} from "@/admin/refine/AdminRefineProvider";
import {AdminAuthProvider, useAdminAuth} from "@/contexts/AdminAuthContext";
import {AdminShell} from "@/components/admin/AdminShell";
import {AdminLoginForm} from "@/components/admin/AdminLoginForm";

function AdminAuthGate({children}: {children: React.ReactNode}) {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const {user, ready, refresh} = useAdminAuth();
  const isLogin = pathname === "/vadmin/login";
  useEffect(() => {
    if(!ready) return;
    if(!isLogin && !user?.authenticated) navigate("/vadmin/login", {replace: true});
    if(isLogin && user?.authenticated) navigate("/vadmin", {replace: true});
  }, [ready, isLogin, user?.authenticated, navigate]);
  useEffect(() => {
    if(isLogin) refresh().catch(() => {});
  }, [isLogin, refresh]);
  if(!ready) return <div className="admin-auth-loading">Loading...</div>;
  if(isLogin) return <>{children}</>;
  if(!user?.authenticated) return null;
  return <>{children}</>;
}

export function AdminLayout() {
  const {pathname} = useLocation();
  const isLogin = pathname === "/vadmin/login";
  return (
    <AdminAuthProvider>
      <AdminRefineProvider>
        <AdminAuthGate>
          {isLogin ? <Outlet /> : (
            <AdminShell>
              <Outlet />
            </AdminShell>
          )}
        </AdminAuthGate>
      </AdminRefineProvider>
    </AdminAuthProvider>
  );
}

export function AdminLoginPage() {
  return <AdminLoginForm />;
}
